import type { FaireProductEntity } from "../../entity_types/product";

export const p_az6zacrhgp: FaireProductEntity = {
  token: "p_az6zacrhgp",
  type: "product",
  name: "Eloise Floral Peplum Blouse",
  brandToken: "b_2mvdyzg3tq",
  brandName: "Olivaceous",
  imageUrl:
    "https://cdn.faire.com/fastly/9bbc5303e63d7703907f9e8532f57b6e6a3a061337f6190fae2459d7572dce24.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/77afa0f3842888c68abdf3bcb68463dff5c272b9561d8220c327c1c16a157335.jpeg",
    "https://cdn.faire.com/fastly/6d8d9c36ccdbde4be668fa2add64c272262967dd33d10b6744ed0630438c0a6c.jpeg",
    "https://cdn.faire.com/fastly/63ed0517931a61635f8bc906fc138a81b9d426f0732873b6e8b9d4e021f9a033.jpeg",
    "https://cdn.faire.com/fastly/2ed5cb39c05d6386fb8e7d98995e6404a13047f0cf151be7dfd145cc1ab570bf.jpeg",
    "https://cdn.faire.com/fastly/35ef2fc92785bad6e5ff7f9aa9a28945500be838e0bdc07fd827a7c4bc57bab2.jpeg",
  ],
  priceDollars: 193.13,
  description:
    "Our Eloise Floral Peplum Blouse features a vibrant floral print and voluminous puff sleeves with lace trim for an effortlessly feminine look. Designed with a split V-neckline and flattering peplum silhouette, it's perfect for brunch dates, weekend outings, and elevated everyday styling.\n\nWoven",
  tags: [],
  msrpDollars: 386.25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-18T16:17:54.721Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
